import { post } from './http'

//获取学生信息
export function getStuInfo(uuid) {
  return post('/tyapi/pc/healthFiles/getStuInfo', {
    uuid: uuid,
  })
}
//获取体测数据
export function getMyHealthGrade(uuid) {
  return post('/tyapi/pc/healthFiles/getMyHealthGrade', {
    uuid: uuid,
  })
}
//获取课外锻炼
export function getMyExercise(uuid) {
  return post('/tyapi/pc/healthFiles/getMyExercise', {
    uuid: uuid,
  })
}
//获取比赛成绩
export function getMyRaceInfo(uuid) {
  return post('/tyapi/pc/healthFiles/getMyRaceInfo', {
    uuid: uuid,
  })
}
//获取体育课成绩
export function getStuTyGradeList(uuid) {
  return post('/tyapi/pc/healthFiles/getStuTyGradeList  ', {
    uuid: uuid,
  })
}
//获取健康监测
export function getMyHealthMonitor(uuid) {
  return post('/tyapi/pc/healthFiles/getMyHealthMonitor', {
    uuid: uuid,
  })
}
